import { createSignal, onCleanup, onMount } from "solid-js";

const images = import.meta.glob("/src/assets/images/thumb-*.jpg", {
  eager: true,
});
const gallery = Object.values(images).map((module) => module.default);

export default function SlidingGallery() {
  const itemWidth = 160;
  const [offset, setOffset] = createSignal(0);

  let interval;

  onMount(() => {
    interval = setInterval(() => {
      setOffset((prev) => {
        const newOffset = prev - itemWidth;
        return Math.abs(newOffset) >= itemWidth * gallery.length
          ? 0
          : newOffset;
      });
    }, 2000);

    onCleanup(() => clearInterval(interval));
  });

  return (
    <div class="flex flex-row space-x-4 overflow-x-clip">
      <div
        class="flex space-x-4 duration-500"
        style={{ transform: `translateX(${offset()}px)` }}
      >
        <For each={[...gallery, ...gallery]}>
          {(src) => <img src={src} class="size-36 rounded-lg shadow-md" />}
        </For>
      </div>
    </div>
  );
}
